<div class="container" fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="0.5%" fxLayoutAlign="center">
  <div class="dash" fxFlex="nogrow">
    <div *ngFor="let tag of openTagCount" class="issue-counts">
      <p class="issue-paragraph">
        <span class="issue-tag">{{ifEmpty(tag.issue_tag_name)}}</span>
        <span class="issue-cat">{{ifEmpty(tag.issue_tag_type_name)}}</span>
        <span class="issue-num">{{tag.num_tags}}</span></p>
    </div>
    <div>
      <span class="first-total-tag">Software: {{openCounts.softwareTotal}}</span>
      <span class="total-tag">Hardware: {{openCounts.hardwareTotal}}</span>
      <span class="total-tag">Wifi: {{openCounts.wifiTotal}}</span>
    </div>
    <div>
      <span class="first-total-tag">Installation: {{openCounts.installationTotal}}</span>
      <span class="total-tag">General Question: {{openCounts.generalQuestionsTotal}}</span>
      <span class="total-tag">Untagged: {{openCounts.untaggedTotal}}</span>
    </div>
    <div>
      <span class="first-total-tag">Total Open: {{TotalTotals(openCounts)}}</span>
    </div>
  </div>
  <div class="dash" fxFlex="auto">
    <div *ngFor="let tag of closedTagCount" class="issue-counts">
      <p class="issue-paragraph">
        <span class="issue-tag">{{ifEmpty(tag.issue_tag_name)}}</span>
        <span class="issue-cat">{{ifEmpty(tag.issue_tag_type_name)}}</span>
        <span class="issue-num">{{tag.num_tags}}</span></p>
    </div>
    <div>
      <span class="first-total-tag">Software: {{closedCounts.softwareTotal}}</span>
      <span class="total-tag">Hardware: {{closedCounts.hardwareTotal}}</span>
      <span class="total-tag">Wifi: {{closedCounts.wifiTotal}}</span>
    </div>
    <div>
      <span class="first-total-tag">Installation: {{closedCounts.installationTotal}}</span>
      <span class="total-tag">General Question: {{closedCounts.generalQuestionsTotal}}</span>
      <span class="total-tag">Untagged: {{closedCounts.untaggedTotal}}</span>
    </div>
        <div>
      <span class="first-total-tag">Total Closed: {{TotalTotals(closedCounts)}}</span>
    </div>
  </div>
</div>
